export enum RelatorioVendasFiltro {
  PENDENTE = 'PENDENTE',
  CONTRATADO = 'CONTRATADO'
}
